import React from "react";
import { FormattedMessage } from "react-intl";

import CNBDatePicker from "components/CNBDatePicker";

import "./style.scss";

const RangeDatepicker = ({
  label = "",
  name = "",
  value = { from: undefined, to: undefined },
  kind = "default",
  handleRangeChange,
  dateClassName = ""
}) => (
  <div className="range-datepicker-block">
    {label && <FormattedMessage id={label} tagName="label" />}
    <div className="range-block">
      <CNBDatePicker
        startDate={value.from}
        onChange={date => handleRangeChange(date, `${name}.from`)}
        className={dateClassName}
        kind={kind}
      />
      <span className="date-label">
        <FormattedMessage id="DATE_LABEL" />
      </span>
      <CNBDatePicker
        startDate={value.to}
        popperPlacement="top-end"
        containerClassName="date-to"
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false
          }
        }}
        onChange={date => handleRangeChange(date, `${name}.to`)}
        className={dateClassName}
        kind={kind}
      />
    </div>
  </div>
);

export default RangeDatepicker;
